import { PhoneNumberFormat, PhoneNumberUtil } from "google-libphonenumber";
import { validarTelefone } from "../../../../../util/validarTelefone";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import React from "react";
import { Message } from "@zendeskgarden/react-forms";
const phoneUtil = PhoneNumberUtil.getInstance();
const DEFAULT_PHONE_REGION = "BR";

// O telefone do currículo pode vir no formato local, sem o código do país
// (ex.: "(19) 99123-4567"); sem interpretá-lo na região padrão ele seria lido
// como um número internacional inválido.
function toInternationalFormat(numero: string) {
  if (numero.startsWith("+")) return numero;

  try {
    const parsed = phoneUtil.parse(numero, DEFAULT_PHONE_REGION);
    if (phoneUtil.isValidNumber(parsed)) {
      return phoneUtil.format(parsed, PhoneNumberFormat.E164);
    }
  } catch (error: any) {
    console.error("Erro ao interpretar telefone do currículo:", error);
  }

  return numero;
}
class Phone extends React.Component<any> {
  state = {
    user: {} as any,
    phoneErrorTelefone: "",
    phoneValue: "",
    phoneTouched: false,
  };

  static getDerivedStateFromProps(nextProps: any, prevState: any) {
    if (nextProps.user && nextProps.user !== prevState.user) {
      const telefoneObj = nextProps.user?.contato?.lista?.find(
        (c: any) => c.tipo?.toLowerCase() === "telefone"
      );
      
      let value = telefoneObj ? telefoneObj.contato : "";
      if (value && !value.startsWith("+")) value = "+" + value;
      
      return {
        user: nextProps.user,
        phoneValue: value,
      };
    }
    return null;
  }
  
  componentDidMount() {
    if (this.props.phone) {
      this.handlePhone(toInternationalFormat(this.props.phone), null);
    }
  }

  componentDidUpdate(prevProps: any) {
    if (this.props.phone && prevProps.phone !== this.props.phone) {
      this.handlePhone(toInternationalFormat(this.props.phone), null);
    }
  }

  isEmptyNumber = (numero: string, user: any) => {
    if (!numero || numero.trim() === "") {
      const index = user.contato.lista.findIndex(
        (c: any) => c.tipo?.toLowerCase() === "telefone"
      );
      if (index >= 0) user.contato.lista.splice(index, 1);
      this.setState({ user, phoneValue: "", phoneErrorTelefone: "" });
      this.props.onChange?.(user);
      return true;
    }
    return false;
  };
  
  setInvalidNumber = (FullNumber: string) => {
    this.setState({ phoneValue: FullNumber, phoneErrorTelefone: "Número inválido" });
    this.props.onError?.("Número De Telefone Inválido");
    return true;
  };
  
  tryValidateNumber = (FullNumber: string, countryCode: string) => {
    try {
      validarTelefone(FullNumber, countryCode);
      this.props.onError?.("");
      return true;
    } catch (e: any) {
      const msg = e.message || "Número De Telefone Inválido";
      this.setState({ phoneErrorTelefone: msg });
      this.props.onError?.(msg);
      return false;
    }
  };
  
  updatePhoneList = (user: any, FullNumber: string, countryCode: string) => {
    const index = user.contato.lista.findIndex(
      (c: any) => c.tipo?.toLowerCase() === "telefone"
    );
    const phoneObj = {
      locale: "pt-BR",
      tipo: "telefone",
      contato: FullNumber,
      pais: countryCode,
    };
    if (index >= 0) user.contato.lista[index] = { ...user.contato.lista[index], ...phoneObj };
    else user.contato.lista.push(phoneObj);
  };

  handlePhone = (numero: string, country: any) => {
  const user = { ...this.state.user };
  if (!user.contato) user.contato = {};
  if (!Array.isArray(user.contato.lista)) user.contato.lista = [];

  const FullNumber = numero.startsWith("+") ? numero : `+${numero}`;

  if (this.isEmptyNumber(numero, user)) return;

  try {
    const parsedNumber = phoneUtil.parse(FullNumber);
    const regionCode = phoneUtil.getRegionCodeForNumber(parsedNumber) || "BR";

    if (!phoneUtil.isValidNumber(parsedNumber)) {
      return this.setInvalidNumber(FullNumber);
    }

    if (!this.tryValidateNumber(FullNumber, regionCode)) return;

    this.updatePhoneList(user, FullNumber, regionCode);
    this.setState(
      { user, phoneValue: FullNumber, phoneErrorTelefone: "" },
      () => this.props.onChange?.(user)
    );

  } catch (error: any) {
    console.error("Erro ao validar telefone:", error);
    this.setState(
      { user, phoneValue: FullNumber, phoneErrorTelefone: "" },
      () => this.props.onChange?.(user)
    );
    this.props.onError?.("Número De Telefone Inválido");
  }
};



  render() {
    const { phoneErrorTelefone, phoneValue, phoneTouched } = this.state;
    const onlyDigits = phoneValue.replaceAll(/\D/g, "");
    const isPortugal = phoneValue.startsWith("+351");

    return (
      <>
        <PhoneInput
          placeholder="Digite o seu telefone"
          value={phoneValue}
          country={"br"}
          enableSearch
          onChange={(value, country: any) => {
            if (!country?.dialCode && !value.startsWith("+")) {
              this.setState({
                phoneErrorTelefone:
                  "Selecione o país antes de digitar o número.",
              });
              if (typeof this.props.onError === "function") {
                this.props.onError("Selecione o país antes de digitar o número.");
              }
              return;
            }
            this.setState({ phoneErrorTelefone: "" });
            if (typeof this.props.onError === "function") {
              this.props.onError("");
            }
            this.handlePhone(value, country);
          }}
          inputClass="mt-2 phone-css"
          onBlur={() => this.setState({ phoneTouched: true })}
          onKeyDown={(e) => {
            if (isPortugal) {
              const d = onlyDigits.startsWith("351")
                ? onlyDigits.slice(3)
                : onlyDigits;
              if (d.length >= 9 && /^\d$/.test(e.key)) {
                e.preventDefault();
              }
            }
          }}
        />

        {phoneTouched && phoneErrorTelefone && (
          <Message validation="error">
            {phoneErrorTelefone}
          </Message>
        )}
      </>
    );
  }
}

export default Phone;